// @module Eureka.MaxaTrendingProducts.TrendingProcuts
define('Eureka.MaxaTrendingProducts.MaxaIreland.View'
    , [
        'PageType.Base.View',
        'eureka_maxatrendingproducts_maxa_ireland.tpl'
    ]
    , function (
        PageTypeBaseView,
        eureka_maxatrendingproducts_maxa_ireland_tpl
    ) {
        'use strict';

        // @class Eureka.MaxaTrendingProducts.TrendingProcuts.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxatrendingproducts_maxa_ireland_tpl

            , initialize: function (options) {

            }

            , beforeShowContent: function beforeShowContent() {
                this.getBreadcrumbPages = function () {
                    return [{
                        text: 'Maxa Ireland',
                        href: ''
                    }];
                };

                return jQuery.Deferred().resolve()


            }

            //@method getContext @return Eureka.MaxaTrendingProducts.TrendingProcuts.View.Context
            , getContext: function getContext() {
                return {};
            }
        });
    });
